import request from "superagent";
import { getAuthHeader } from "../../../utils/superagent";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'adminId' implicitly has an 'any' type.
const updateHCPStage = async ({ adminId, adminName, agentId, stage, substage, reason, note }) => {
  return (
    request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .put(`${global.api}/agentProfile/stage`)
      .set(await getAuthHeader())
      .send({
        adminId,
        adminName,
        agentId,
        stage,
        substage,
        reason,
        note,
      })
  );
};

export { updateHCPStage };
